import type { IntlShape } from 'react-intl';
import { FAQParkAggregatesType } from '../../../types/locationDetailsPages/shared';
import { FaqFilterType } from '../types';
import { getParkAggregatesQuestionStrings, ParkAggregatesAnswerWithFilter } from './ParkAggregateMessages';

export const getParkAggregatesQuestion = (intl: IntlShape, locationName: string, filter?: FaqFilterType) => {
  return getParkAggregatesQuestionStrings(intl, locationName, filter);
};

type ParkAggregatesAnswerProps = {
  filter: FaqFilterType;
  locationName: string;
  faqParkAggregates: FAQParkAggregatesType;
  intl: IntlShape;
};

export const ParkAggregatesAnswer = ({ filter, locationName, faqParkAggregates, intl }: ParkAggregatesAnswerProps) => {
  const { totalTrails, averageRating, reviewCount } = faqParkAggregates;
  const displayAverageRating = intl.formatNumber(Number(averageRating), { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  return (
    <ParkAggregatesAnswerWithFilter
      filter={filter}
      locationName={locationName}
      trailCount={intl.formatNumber(totalTrails)}
      rating={displayAverageRating}
      reviewCount={intl.formatNumber(reviewCount)}
      intl={intl}
    />
  );
};
